import * as React from 'react';
import { useEffect, useState } from 'react';
import { Router } from 'react-router';
import ClippyTrigger from '../react/features/Clippy/components/Trigger/lazy';
import { CompanyDesignProvider } from '../react/services/CompanyDesignProvider';
import * as keyEventStackService from '../react/services/KeyEventStack';
import AppRoutes from '../routing/Routes';
import history, { globalClickHandler } from '../routing/history';
import AppShell from './AppShell';

const useGlobalLinkClickListener = () => {
    useEffect(() => {
        document.addEventListener('click', globalClickHandler);
        return () => document.removeEventListener('click', globalClickHandler);
    }, []);
};

const useNavigationToggleState = () => {
    const [showNavigation, setShowNavigation] = useState(false);

    useEffect(() => {
        if (showNavigation) {
            const className = 'main-navigation-open';
            document.body.classList.add(className);

            const keyEvent = {
                onKey: (event: unknown) => {
                    if (keyEventStackService.isEsc(event)) {
                        setShowNavigation(false);
                        return false;
                    }
                },
            };
            keyEventStackService.register(keyEvent);

            const unlisten = history?.listen(() => setShowNavigation(false));

            return () => {
                document.body.classList.remove(className);
                keyEventStackService.deregister(keyEvent);
                unlisten?.();
            };
        }
    }, [showNavigation]);

    return { showNavigation, setShowNavigation };
};

const App: React.FC = () => {
    useGlobalLinkClickListener();
    const { showNavigation, setShowNavigation } = useNavigationToggleState();

    return (
        <Router history={history!}>
            <CompanyDesignProvider>
                <AppShell showNavigation={showNavigation} setShowNavigation={setShowNavigation}>
                    <AppRoutes />
                </AppShell>
            </CompanyDesignProvider>

            <aside id="clippy">
                <ClippyTrigger />
            </aside>
        </Router>
    );
};

export default App;
